import { apiService } from '../api';
import { ApiResponse, PaginatedResponse } from '../../types/api';
import { ClientFilters } from '../../types/client';
import type { Client, CreateClientRequest, UpdateClientRequest } from '../../types/api';

class ClientService {
  async getClients(params?: ClientFilters): Promise<PaginatedResponse<Client>> {
    // Convert ClientFilters to apiService compatible parameters.
    // Round 8 lesson: every new filter field MUST be added here AND on the
    // strict type in api.ts — extra keys are silently stripped otherwise.
    const apiParams = params ? {
      page: params.page,
      per_page: params.per_page,
      search: params.search,
      status: params.status,
      no_accounts: params.no_accounts
    } : undefined;

    return await apiService.getClients(apiParams);
  }

  async getClient(id: number): Promise<ApiResponse<Client>> {
    return await apiService.getClient(id);
  }

  async createClient(data: CreateClientRequest): Promise<ApiResponse<Client>> {
    return await apiService.createClient(data);
  }

  async updateClient(id: number, data: UpdateClientRequest): Promise<ApiResponse<Client>> {
    return await apiService.updateClient(id, data);
  }

  async deleteClient(id: number, force = false): Promise<ApiResponse<any>> {
    return await apiService.deleteClient(id, force);
  }

  async toggleClientStatus(id: number): Promise<ApiResponse<Client>> {
    return await apiService.toggleClientStatus(id);
  }

  async bulkAssignEmployees(
    clientId: number,
    employees: Array<{ user_id: number; commission_percentage: number }>,
    applyTo: 'all_accounts' | 'active_accounts_only',
    overwriteExisting: boolean
  ): Promise<ApiResponse<any>> {
    return await apiService.bulkAssignEmployeesToClient(clientId, {
      employees,
      apply_to: applyTo,
      overwrite_existing: overwriteExisting
    });
  }
}

export const clientService = new ClientService();
export default clientService;